import { render, staticRenderFns } from "./DataFList.vue?vue&type=template&id=5de6749e&scoped=true"
import script from "./DataFList.vue?vue&type=script&lang=js"
export * from "./DataFList.vue?vue&type=script&lang=js"
import style0 from "./DataFList.vue?vue&type=style&index=0&id=5de6749e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de6749e",
  null
  
)

export default component.exports